import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash.isempty'
import isNil from 'lodash.isnil'
import { Route, Redirect } from 'react-router-dom'
import { removeLoginToken, setRedirectUrl } from 'src/utils/helpers'

class PrivateRoute extends PureComponent {
  static defaultProps = {
    user: null,
    component: null,
  }

  static propTypes = {
    user: PropTypes.object,
  }

  renderPrivateRouteBody = props => {
    const { user, component, location, isWidgetState } = this.props

    // React component neeed to be uppercase
    const Component = component //eslint-disable-line

    if (!isEmpty(user) && !isNil(Component)) {
      return <Component {...props} />
    }

    // edge case when user is not available but token is not deleted
    if (isEmpty(user)) {
      removeLoginToken()
    }

    // save previous private route
    if (!isEmpty(location) && !isWidgetState) {
      setRedirectUrl(location && location.pathname)
    }

    return (
      <Redirect
        to={{
          pathname: '/auth/login',
          state: {
            listItem: location && location.state && location.state.listItem,
          },
        }}
      />
    )
  }

  render() {
    return <Route path={this.props.path} render={this.renderPrivateRouteBody} />
  }
}

export default PrivateRoute
